import React, { useState} from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "./Component.css";
import Table from 'react-bootstrap/Table';


const Popup=(props)=> {

    
    const handleClose=()=> {
        props.updateModalStates(false, []);
    };

    return (
        
        <Modal
            size="xl"
            show={props.show}
            onHide={handleClose}
            scrollable={true}
            dialogClassName="modal-90w"
            className="modal-90w"
        >

            <Modal.Header closeButton>
                <Modal.Title>Version History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table bordered hover responsive>
                    <tbody>
                        <tr>
                            <th>Open API Json</th>
                            <th>Postman Collection</th>
                            <th>Version</th>
                            <th>Uploaded By</th>
                            <th>Uploaded On</th>
                            <th>OpenAPI</th>
                            <th>Postman Collection</th>
                        </tr>
                        {props.data}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
        
    )
    
}

export default Popup;





